import React, { Fragment } from 'react'
import Homebanner from '../../Components/Home/Homebanner'
import TrendingThings from '../../Components/Home/TrendingThings'
import Features from '../../Components/Home/Features'
import AudioBook from '../../Components/Home/AudioBook'
import RelatedBooks from '../../Components/Home/RelatedBooks'
import AboutTRen from '../../Components/Home/AboutTRen'

const Home = () => {
    return (
        <Fragment>
            <Homebanner />
            <TrendingThings />
            <Features />
            <AudioBook />
            <RelatedBooks />
            <AboutTRen />
        </Fragment>
    )
}

export default Home